<template>
    <div>
        <PageDocumentFormDebug v-bind:config="config" v-bind:contract-data="contractData" v-bind:formresult="formresult" v-on:loaded="debugLoaded" v-on:submissionchanged="submissionChanged" v-bind:submission="submission" v-bind:current-contract-id="currentContractId()" ref="debug"></PageDocumentFormDebug>

        <KTPortlet
                v-bind="{
            }"
                v-bind:class="{ 'kt-spinner-f': loading }"
        >
            <template v-slot:title>
                <h4 class="">{{ isNew() ? 'Nuovo contratto':'Visualizza contratto' }} {{label}}</h4>
                <div class="copy-code" v-if="randomCode">
                    <input type="text" v-model="randomCode">
                    <button type="button" @click="doCopy"><i class="flaticon2-clip-symbol"></i></button>
                </div>
                <b-button v-if="submission.generaldata && enableDuplicate" style="height: 27px;line-height: 9px;margin: -6px 0 0 0;" :to="{name:'document-submission-copy', params:{'id':currentContractId(),'csid':currentSubmissionId()}}" class="mr-2 btn-primary">Duplica</b-button>
            </template>
            <template v-slot:body>
                <!--                                <app-customform v-if="config" v-bind:configinput="JSON.stringify(config)"></app-customform>-->
                <formio v-bind:class="{ 'formio-readonly': config.options.readOnly }" id="formfinal" ref="formfinal"
                        v-on:render="onRender"
                        v-on:prevPage="onPrevPage"
                        v-on:nextPage="onNextPage"
                        v-bind:url="config.formurl" v-if="config.form && loadedDebug"
                        v-bind:form="config['form']" v-bind:submission="submission" v-bind:options="config['options']"
                        v-on:change="onFormChange" readOnly="config.options.readOnly"
                        language="it"></formio>
                <div v-if="featureDraftEnabled && !config.options.readOnly && submission.data && loadedDebug && !isEditing" style="text-align: right">
                    <button @click="saveDraft" style="width: fit-content" class="btn btn-warning">Salva bozza</button>
                </div>

            </template>
        </KTPortlet>

        <KTPortlet
                v-bind="{
            }"
                v-if="submission.generaldata"
                v-bind:class="{ 'kt-spinner-f': loading }"
        >
            <template v-slot:title>
                <h4 class="">{{ 'Informazioni' }}</h4>
            </template>
            <template v-slot:body>
                <table class="table-info">
                    <tbody>
                    <tr v-if="submission.generaldata.status">
                        <td>STATO</td>
                      <td><span v-if="statusesloaded">{{statuses[submission.generaldata.status]}}</span></td>
                    </tr>
                    <tr v-if="submission.generaldata.created_at">
                        <td>Data creazione</td>
                        <td>{{submission.generaldata.created_at | formatDate}}</td>
                    </tr>
                    <tr v-if="submission.generaldata.sent_at">
                        <td>Data invio</td>
                        <td>{{submission.generaldata.sent_at | formatDate}}</td>
                    </tr>
                    <tr v-if="submission.generaldata.expires_at">
                        <td>Data scadenza</td>
                        <td>{{submission.generaldata.expires_at | formatDate}}</td>
                    </tr>
                    <tr v-if="submission.generaldata.signed_at">
                        <td>Data firma</td>
                        <td>{{submission.generaldata.signed_at | formatDate}}</td>
                    </tr>
                    <tr v-if="submission.generaldata.instantCallJob && submission.generaldata.instantCallJob.status">
                        <td>Stato Instant Call</td>
                        <td>{{submission.generaldata.instantCallJob.status}}</td>
                    </tr>
                    <tr v-if="submission.generaldata.instantCallJob && submission.generaldata.instantCallJob.note">
                        <td>Dettaglio Stato Instant</td>
                        <td>{{submission.generaldata.instantCallJob.note}}</td>
                    </tr>
                    <tr v-if="submission.generaldata.instantCallJob && submission.generaldata.instantCallJob.sent_at">
                        <td>Data invio Instant Call</td>
                        <td>{{submission.generaldata.instantCallJob.sent_at | formatDate}}</td>
                    </tr>
                    <tr v-if="submission.generaldata.instantCallJob && submission.generaldata.instantCallJob.callback_at">
                        <td>Data Callback Instant Call</td>
                        <td>{{submission.generaldata.instantCallJob.callback_at | formatDate}}</td>
                    </tr>
                    <tr v-if="submission.generaldata.instantCallJob && submission.generaldata.instantCallJob.eva_status">
                        <td>Stato EVA</td>
                        <td>{{submission.generaldata.instantCallJob.eva_status}}</td>
                    </tr>
                    <tr v-if="submission.generaldata.instantCallJob && submission.generaldata.instantCallJob.eva_sent_at">
                        <td>Data invio a EVA</td>
                        <td>{{submission.generaldata.instantCallJob.eva_sent_at | formatDate}}</td>
                    </tr>
                    <tr v-if="submission.generaldata.instantCallJob && submission.generaldata.instantCallJob.eva_error ">
                        <td>Errore EVA</td>
                        <td>{{submission.generaldata.instantCallJob.eva_error}}</td>
                    </tr>
                    </tbody>
                </table>

            </template>
        </KTPortlet>
    </div>
</template>
<style>
    #formfinal .pagination {
        display: block;
        list-style-type: none;
    }

    #formfinal .pagination .page-item {
        display: inline-block;
        cursor: pointer;
    }

    #formfinal .alert ul {
        display: block;
        margin: 27px 0;
    }

    #formfinal .maxwidth500 {
        max-width: 500px;
        margin: 0 auto;
    }

    .formio-day-component-day {
        width: 100%;
    }


    .formio-form ::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #ddd;
    }

    .formio-form :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #ddd;
    }

    .formio-form ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #ddd;
    }

    .formio-form :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #ddd;
    }

    .formio-form input::placeholder {
        color: #ddd;
    }

    .formio-form textarea::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #ddd;
    }

    .formio-form textarea:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #ddd;
    }

    .formio-form textarea::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #ddd;
    }

    .formio-form textarea:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #ddd;
    }

    .formio-form textarea::placeholder {
        color: #ddd;
    }

    .formio-readonly ::-webkit-input-placeholder {
        /* WebKit browsers */
        color: transparent;
    }

    .formio-readonly :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: transparent;
    }

    .formio-readonly ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: transparent;
    }

    .formio-readonly :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: transparent;
    }

    .formio-readonly input::placeholder {
        color: transparent;
    }

    .formio-readonly textarea::-webkit-input-placeholder {
        /* WebKit browsers */
        color: transparent;
    }

    .formio-readonly textarea:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: transparent;
    }

    .formio-readonly textarea::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: transparent;
    }

    .formio-readonly textarea:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: transparent;
    }

    .formio-readonly textarea::placeholder {
        color: transparent;
    }

    .table-info {
        max-width: 400px;
    }

    .table-info td {
        border: 1px solid #ccc;
        width: 1%;
        white-space: nowrap;
        padding: 10px;
    }

    .table-info tr:nth-child(even) {
        background: #CCC
    }

    .table-info tr:nth-child(odd) {
        background: #FFF
    }

    .form-test textarea {
        min-height: 300px;
    }


    .copy-code {
        margin: -7px 50px 0;
        border: 1px solid #ccc;
        padding: 4px;
    }

    .copy-code input {
        width: 100px;
    }

    .formio-select-autocomplete-input {
        /* we can't use display: none or visibility: hidden because autocomplete won't work on hidden field */
        /* https://github.com/formio/formio.js/commit/e0b2e3a671aeacad503d0ae25d79d204d3d68bfb */
        display:none !important;
        visibility: hidden !important;
    }
</style>
<script>
    import {SET_BREADCRUMB} from "@/store/breadcrumbs.module";
    import KTPortlet from "@/views/partials/content/Portlet.vue";
    import {Form, FormBuilder} from 'vue-formio'; // used by builder only
    import ApiService from "../../../common/api.service";
    import UserService from "../../../common/user.service";
    import Vue from "vue";
    // import './../../../../public/assets/js/output-es5.js';
    // import temporaryform from "./temporaryform"; // TODO REMOVE
    // import temporaryformdata from "./temporaryformdata"; // TODO REMOVE
    import JwtService from "@/common/jwt.service";
    import $ from 'jquery';
    import VueClipboard from 'vue-clipboard2'
    import UtilService from "../../../common/util.service";
    import PageDocumentFormDebug from "../../partials/pages/document/form/Debug";
    import {FEATURE_DRAFT_ENABLED} from "../../../common/config";

    export default {
        data() {
            return {
                enableDuplicate: false,
                featureDraftEnabled: FEATURE_DRAFT_ENABLED,
                contractData: null,
                loading: false,
                label: null,
                randomCode: null,
                isDraft: false,
                isEditing: false,
                contractId: null,
                formresult: null,
                loadedDebug: false,
                statusesloaded:0,
                // statusesSelect:[],
                statuses:[],
                submission: {
                    data: {},
                    generaldata: null
                },
                config: {
                    formbuilder: null,
                    formurl: Vue.axios.defaults.baseURL,
                    // windowCallbackFormBeforeSubmit:'extVueFormBeforeSubmit',
                    options: {
                        hooks: {
                            beforeSubmit: (submission, callback) => {
                                console.log('extVueFormBeforeSubmit received', submission, callback);
                                // callback({
                                //     message: "Something bad happened.",
                                //     component: null
                                // }, null);
                                this.submit(submission, callback);
                            }
                        },
                        readOnly: false,
                        // base:Vue.axios.defaults.baseURL,
                        // project:Vue.axios.defaults.baseURL,
                        i18n: {
                            it: {
                                'alertMessage': '{{label}}: {{message}}',
                                'cancel': 'Annulla',
                                'previous': 'Precedente',
                                'Previous': 'Precedente',
                                'next': 'Successivo',
                                'Next': 'Successivo',
                                'Submit': 'Invia',
                                'submit': 'Invia',
                                'required': 'Richiesto',
                                'error': 'Errore',
                                'complete': 'Inviato',
                                'Type to search': 'Digita per cercare',
                                'Day': 'Giorno',
                                'Month': 'Mese',
                                'Year': 'Anno',
                                'January': 'Gennaio',
                                'February': 'Febbraio',
                                'March': 'Marzo',
                                'April': 'Aprile',
                                'May': 'Maggio',
                                'June': 'Giugno',
                                'July': 'Luglio',
                                'August': 'Agosto',
                                'September': 'Settembre',
                                'October': 'Ottobre',
                                'November': 'Novembre',
                                'December': 'Dicembre',
                            }
                        }
                    },
                    form: null,
                    formsubmit: null,
                    forminit: null
                }
            }
        },
        components: {
            KTPortlet,
            formio: Form,
            PageDocumentFormDebug
        },
        mounted() {
            ApiService.get('lists/sw/status')
                .then(({data}) => {
                  data.forEach((x) => {
                    this.statuses[x.id] = x.label;
                    // this.statusesSelect.push({value: x.id, text: x.label});
                  });
                  this.statusesloaded=1;
                })
                .catch(({response}) => {
                  //context.commit(SET_ERROR, response.data.errors);
                });

            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Documenti", route: "/document"},
                {title: "Contratto"}
            ]);

            Vue.use(VueClipboard);


            // window['extVueFormBeforeSubmit'] = function(submission,callback){
            //     console.log('extVueFormBeforeSubmit received',submission,callback);
            //     // callback({
            //     //     message: "Something bad happened.",
            //     //     component: null
            //     // }, null);
            //     callback(null, submission);
            // };
            this.reload();


        },

        created() {
            this.isDraft = this.$route.name === 'document-draft-view';
            this.isEditing = this.$route.name === 'document-submission-edit';
        },

        methods: {
            doCopy: function () {
                this.$copyText(this.randomCode).then(function (e) {
                    // alert('Copied')
                    // console.log(e)
                }, function (e) {
                    // alert('Can not copy')
                    // console.log(e)
                })
            },
            reload: function () {
                this.loading = true;
                this.config.options.readOnly = !this.isNew() && !this.isDraft && !this.isEditing;
                let that = this;
                let promises = [
                    new Promise(resolve => {
                        ApiService.get('contracts/' + this.currentContractId())
                            .then(({data}) => {



                              ApiService.get('contracts')
                                  .then( data2  => {
                                    that.enableDuplicate = !!data2.data.rows.find((x) => x.id == that.currentContractId());
                                  })
                                  .catch(({ response }) => {
                                    //context.commit(SET_ERROR, response.data.errors);
                                  });




                                this.contractData = data;
                                this.label = data.contract.label;
                                //this.config.form = JSON.parse(data.contract.form);
                                let formdata = JSON.parse(data.contract.form);

                                //this.config.form = JSON.parse(JSON.stringify(temporaryform).replace(/BASEAPIURL/g,Vue.axios.defaults.baseURL));
                                // if(this.useDebugData()){
                                //     this.config.form = JSON.parse(JSON.stringify(temporaryform).replace(/MAINAPITOKEN/g, JwtService.getToken()));
                                //     this.submission.data = temporaryformdata;
                                // }else{
                                const formConfig = JSON.parse(JSON.stringify(formdata.form).replace(/MAINAPITOKEN/g, JwtService.getToken()));

                                // window.see = formConfig;

                                this.config.form = formConfig;


                                // }
                                //
                                //
                                // window.formio = this.config['form']; //TODO can be removed

                                if (formdata.formsubmit) {
                                    this.config.formsubmit = formdata.formsubmit;

                                }
                                if (formdata.forminit) {
                                    this.config.forminit = formdata.forminit;
                                }
                                if (!this.currentSubmissionId()) {
                                    if (this.config.forminit) {
                                        try {
                                            var submission = this.submission;
                                            eval(this.config.forminit);
                                        } catch (e) {
                                            console.warn(e);
                                        }
                                    }

                                }

                                if (this.$refs.debug.isSuperDebugUser()) {
                                    //https://github.com/formio/formio.js/issues/2361
                                    setTimeout(function () {
                                        that.$refs.debug.loaded();
                                    }, 1)

                                    // this.$refs.formBuilder.buildForm(this.config.form);
                                }else{
                                    this.loadedDebug = true;
                                }



                                // Fill data if any from query string
                                const query = new URLSearchParams(window.location.href.split('?')[1]);
                                const queryformdata = {};
                                for(var pair of query.entries()) {
                                  var m = pair[0].match(/form\[(.*?)\]/);
                                  if(m){
                                    queryformdata[m[1]] = pair[1];
                                  }
                                }
                                if(Object.keys(queryformdata).length){
                                  this.submission.data = Object.assign(this.submission.data, queryformdata);
                                }

                                // Fill used by fastsign => CRM workflow
                                const paramFormdata = query.get('formdata');
                                if(paramFormdata){
                                  this.submission.data = Object.assign(this.submission.data, Object.assign(data, JSON.parse(paramFormdata)));
                                }

                                resolve(data);

                            })
                            .catch(({response}) => {
                                console.log(response);
                                //context.commit(SET_ERROR, response.data.errors);
                            });
                    })
                ];
                const currentSubmissionOrDuplicateSubmissionId = this.currentSubmissionId() ? this.currentSubmissionId() : this.currentDuplicateSubmissionId();
                if (currentSubmissionOrDuplicateSubmissionId) {
                    promises.push(new Promise(resolve => {
                        ApiService.get((this.isDraft ? 'drafts/' : 'submissions/') + currentSubmissionOrDuplicateSubmissionId)
                            .then(({data}) => {


                                let parse = this.isDraft ? JSON.parse(data.data).data : JSON.parse(data.submission);
                                if(this.currentDuplicateSubmissionId()) {
                                  delete parse.submission.agent;
                                  delete parse.submission.agent_pwd;
                                }
                                this.submission.data = parse.submission;



                                if(!this.currentDuplicateSubmissionId()) { // If not cloning

                                  this.submission.generaldata = data;

                                  if (parse && parse.data && parse.data.codice_contratto) {
                                    this.randomCode = parse.data.codice_contratto;
                                  }

                                }

                                resolve(data);
                            })
                            .catch(({response}) => {
                                //context.commit(SET_ERROR, response.data.errors);
                            });
                    }));
                }
                Promise.all(
                    promises).then(() => {


                    this.loading = false;
                });

                // Click to next button scroll to top
                $('body').on('click', '.btn-wizard-nav-next', null, function () {
                    $('html, body').animate({scrollTop: $('#formfinal').offset().top - 150}, 100);
                });
            },
            isNew: function () {
                return !this.currentSubmissionId();
            },
            submissionChanged: function(s){
                this.submission.data = s;
                this.submission = Object.assign({}, JSON.parse(JSON.stringify(this.submission)));
            },
            debugLoaded: function(s){
                this.loadedDebug = true;
            },
            currentSubmissionId: function () {
                return this.$router.currentRoute.params.sid;
            },
            currentDuplicateSubmissionId: function () {
                return this.$router.currentRoute.params.csid;
            },
            currentContractId: function () {
                return this.$router.currentRoute.params.id+'';
            },
            //
            // isSubmissionView: function () {
            //     return this.currentSubmissionId();
            // },


            // useDebugData: function () {
            //     return this.$router.currentRoute.query.debugdata2 && UserService.isSuperDebugUser();
            // },

            submit: function (submission, callback) {
                console.log('submission', submission);
                let that = this;
                let senddata = null;
                this.loading = true;
                if (this.config.formsubmit) {
                    (function (submission) {
                        var formresult = {data: {submission: submission}};
                        try {
                            eval(that.config.formsubmit);
                        } catch (exceval) {
                            console.log('EVAL ERROR', exceval);
                            that.$customdebugtracker.error('FORM SUBMIT EVAL ERROR', {'error': exceval, 'stack': JSON.stringify(exceval.stack), 'form': JSON.stringify(formresult), 'contractId': that.currentContractId()} );
                            Vue.customNotifyError('Errore nei dati', 'Si prega di riprovare');
                            callback('Errore nei dati inseriti, si prega di verificare il form e riprovare. Una notifica è stata inviata per analizzare l\'errore');
                            that.loading = false;
                            // formresult = 'ERRORE JS SUBMIT';
                            return;
                        }
                        that.formresult = formresult;
                    })(submission.data);
                } else {
                    that.formresult = {data: {submission: submission.data}};
                }
                senddata = that.formresult;

                if(!senddata){
                    callback('Errore nei dati inseriti, si prega di verificare il form e riprovare. Una notifica è stata inviata per analizzare l\'errore');
                    return;
                }

                if (this.$refs.debug.enableDebugSend()) {
                    Vue.customNotifySuccess('Debug');
                    //this.loading=false;
                    //return;
                    senddata.dry_run = 1;
                }

// console.log('POST',senddata);
// return;
//
//                 const callbackList = this.isDraft ?
//                     ApiService.post(('drafts') + (this.isNew() ? '' : '/' + this.currentSubmissionId()), senddata) :
//                     ApiService.post(('submissions') + (this.isNew() ? '' : '/' + this.currentSubmissionId()), senddata);

                const callbackList =
                    ApiService.post(('submissions') + (this.isNew() || this.isDraft ? '' : '/' + this.currentSubmissionId()), senddata);


                callbackList
                    .then(({data}) => {


                        if (this.isNew() || this.isDraft || this.isEditing) {
                            callback(null);
                            Vue.customNotifySuccess('Salvato');
                            /*this.$router.push({ name: "document-submission-view", 'params':{'sid':data.id,'id':data.contract_configuration_id} }, () => {
                                this.reload();
                            });*/
                            if (that.$refs.debug.enableDebugSend()) {
                                that.$refs.debug.debugSendData(data)

                                this.loading = false;
                            } else {

                                if(this.isDraft){
                                    ApiService.delete('drafts/'+this.currentSubmissionId(),{'id':this.currentSubmissionId()}).then(() => {
                                        this.$router.push({
                                            name: "document-history",
                                            query: {'filter_contract': data.contract_configuration_id}
                                        }, () => {
                                            //this.reload();
                                        });
                                    });
                                }else {

                                    this.$router.push({
                                        name: "document-history",
                                        query: {'filter_contract': data.contract_configuration_id}
                                    }, () => {
                                        //this.reload();
                                    });
                                }
                            }
                            // this.$router.go();
                            // this.loading = false;
                            //this.reload();
                        } else {
                            callback(null);
                            Vue.customNotifySuccess('Salvato');
                            // this.loading = false;
                            this.reload();
                        }
                        if (!that.$refs.debug.enableDebugSend()) {
                            this.config.options.readOnly = true;
                        }
                        //
                        //
                        //https://bootstrap-vue.js.org/docs/components/toast/
                        // this.$bvToast.toast(`This is toast number ${this.toastCount}`, {
                        //     title: 'BootstrapVue Toast',
                        //     autoHideDelay: 5000,
                        //     appendToast: append
                        // })

                    })
                    .catch(({response}) => {
                        let errormessage;
                        if(!response){
                            errormessage = 'Errore di connessione, si prega di riprovare';
                        }else {
                            //context.commit(SET_ERROR, response.data.errors);
                            errormessage = response.data && response.data.errors && Array.isArray(response.data.errors) ? response.data.errors.join(', ') : 'Errore, si prega di riprovare';
                        }
                        Vue.customNotifyError('Errore', errormessage);
                        callback(errormessage);
                        that.$customdebugtracker.warn('FORM SUBMIT ERROR '+errormessage, {'response': response} );
                        $('#formfinal .alert').removeClass('alert-success').addClass('alert-danger');
                        $('#formfinal .alert p').text(errormessage);
                        this.loading = false;
                    });
            },

            saveDraft: function (submission) {
                const callback = (message) => {
                    if (message){
                        alert(message);
                    }
                };

                let that = this;
                let senddata = null;
                this.loading = true;

                senddata =  {data: {submission: this.submission.data}};

                senddata.contract_configuration_id = this.contractData.contract.id;
                // senddata.contract_template_id = this.contractData.templates[0].id;
                senddata.organization_id = this.contractData.contract.organization_id;

                if(!senddata){
                    callback('Errore nei dati inseriti, si prega di verificare il form e riprovare. Una notifica è stata inviata per analizzare l\'errore');
                    return;
                }
                //
                // if (this.$refs.debug.enableDebugSend()) {
                //     Vue.customNotifySuccess('Debug');
                //     //this.loading=false;
                //     //return;
                //     senddata.dry_run = 1;
                // }

// console.log('POST',senddata);
// return;
                ApiService.post(('drafts') + (this.isNew() ? '' : '/' + this.currentSubmissionId()), senddata)
                    .then(({data}) => {


                        if (this.isNew()) {
                            callback(null);
                            Vue.customNotifySuccess('Salvato');
                            /*this.$router.push({ name: "document-submission-view", 'params':{'sid':data.id,'id':data.contract_configuration_id} }, () => {
                                this.reload();
                            });*/
                            if (that.$refs.debug.enableDebugSend()) {
                                that.$refs.debug.debugSendData(data)

                                this.loading = false;
                            } else {
                                this.$router.push({
                                    name: "document-history-drafts",
                                    query: {'filter_contract': data.contract_configuration_id}
                                }, () => {
                                    //this.reload();
                                });
                            }
                            // this.$router.go();
                            // this.loading = false;
                            //this.reload();
                        } else {
                            callback(null);
                            Vue.customNotifySuccess('Salvato');


                            this.$router.push({
                                name: "document-history-drafts",
                                query: {'filter_contract': data.contract_configuration_id}
                            }, () => {
                                //this.reload();
                            });

                            // this.loading = false;
                            this.reload();
                        }
                        if (!that.$refs.debug.enableDebugSend()) {
                            this.config.options.readOnly = true;
                        }
                        //
                        //
                        //https://bootstrap-vue.js.org/docs/components/toast/
                        // this.$bvToast.toast(`This is toast number ${this.toastCount}`, {
                        //     title: 'BootstrapVue Toast',
                        //     autoHideDelay: 5000,
                        //     appendToast: append
                        // })

                    })
                    .catch(({response}) => {
                        let errormessage;
                        if(!response){
                            errormessage = 'Errore di connessione, si prega di riprovare';
                        }else {
                            //context.commit(SET_ERROR, response.data.errors);
                            errormessage = response.data && response.data.errors && Array.isArray(response.data.errors) ? response.data.errors.join(', ') : 'Errore, si prega di riprovare';
                        }
                        Vue.customNotifyError('Errore', errormessage);
                        callback(errormessage);
                        that.$customdebugtracker.warn('FORM SUBMITDRAFT ERROR '+errormessage, {'response': response} );
                        $('#formfinal .alert').removeClass('alert-success').addClass('alert-danger');
                        $('#formfinal .alert p').text(errormessage);
                        this.loading = false;
                    });
            },
            onRender: function(){
                //console.log('on form render');
                // https://github.com/formio/formio.js/wiki/Form-Renderer#events
                $(".formio-select-autocomplete-input").each(function(){
                    if(!$(this).attr('autocomplete')) {
                        $(this).attr("autocomplete", "randomStringFormioNoAutocomplete");
                    }
                });
            },
            onPrevPage: function(){
                //console.log('on form onPrevPage');
            },
            onNextPage: function(){
                //console.log('on form onNextPage');
            },
            onFormChange:function(e){
                window.formSubmissionData = JSON.stringify(e.data); // easier export for tools
                if(this.$refs && this.$refs.debug && this.$refs.debug.formChange) {
                    this.$refs.debug.formChange(e);
                    setTimeout(function(){
                        $(".formio-select-autocomplete-input:not([autocomplete])").each(function(){
                            // if(!$(this).attr('autocomplete')) {
                                $(this).attr("autocomplete", "randomStringFormioNoAutocomplete");
                            // }
                        });
                    });
                }
            }
        },
    };
</script>
